(function ($) {
    $(function () {

        // Image slider exists?
        if ($('.flexible-content-section .image-slider').length < 1) {
            return;
        }

        /**
         * Missing forEach on NodeList for IE11.
         * 
         * See: https://github.com/miguelcobain/ember-paper/issues/1058
         */
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = Array.prototype.forEach;
        }

        // Remove classes
        $('.flexible-content-section .image-slider .image-slider__slide-wrap').removeClass('image-slider__slide-wrap--no-js');
        $('.flexible-content-section .image-slider .image-slider__controls-wrap').removeClass('image-slider__controls-wrap--no-js');

        // Append controls
        var controlPrev = '<button class="control control--prev"></button>';
        var controlNext = '<button class="control control--next"></button>';
        $('.flexible-content-section .image-slider .image-slider__controls-wrap').append(controlPrev);
        $('.flexible-content-section .image-slider .image-slider__controls-wrap').append(controlNext);

        const flexContentSliders = document.querySelectorAll('.flexible-content-section .image-slider');

        /**
         * Some pages may have more than one image slider.
         * The following is required to make the slider
         * component work on regardless of how many are
         * on the page.
         * 
         * Refer to: https://github.com/ganlanyuan/tiny-slider/issues/653
         */
        flexContentSliders.forEach(function (slider) {
            // Initialise slider/carousel
            var flexContentImageSlider = tns({
                container: slider.querySelector('.image-slider__slide-wrap'),
                items: 1,
                autoplay: true,
                autoplayButtonOutput: false,
                autoplayTimeout: 7000,
                speed: 1000,
                loop: true,
                nav: true,
                navPosition: 'bottom',
                navContainer: slider.querySelector('.image-slider__controls-wrap .pager-wrap'),
                mouseDrag: false,
                arrowKeys: false,
                touch: true,
                controls: true,
                nextButton: slider.querySelector('.image-slider__controls-wrap .control--next'),
                prevButton: slider.querySelector('.image-slider__controls-wrap .control--prev'),
                preventActionWhenRunning: true,
            });
        });

    });
})(jQuery);